function isSet(value: unknown): value is Set<any> {
  return value instanceof Set;
}

export { isSet };
